import { memo } from 'react';
import { clsx } from 'clsx';
import { FormattedMessage } from 'react-intl';
import { Text } from '@hst-horizon/horizon-ui';
import styles from './SimilarImageIndicator.module.css';

const SimilarImageIndicator = ({
    start = false,
    small = false,
    centred = false,
}: {
    start?: boolean;
    small?: boolean;
    centred?: boolean;
}) => {
    return (
        <div
            className={clsx(styles.similarImageMessage, {
                [styles.showAtStart]: start,
                [styles.centred]: centred,
                [styles.small]: small,
            })}
        >
            <Text primary={!small} secondary={small} medium>
                <FormattedMessage id="similar image" />
            </Text>
        </div>
    );
};

export default memo(SimilarImageIndicator);
